import { FieldParameter } from "@fartherfinance/frontend/api/TaskWorkflows/Types";
import {
  isEnumValue,
  isExpr,
  isResolvedResource,
} from "@fartherfinance/frontend/api/TaskWorkflows/utils/guards";

import { EnumOption } from "../../core/types";
import { resolveExpression } from "../../expressions/resolveExpressions";

export const resolveDefaultEnumValue = (
  fieldParameter: FieldParameter,
  options: EnumOption[]
): EnumOption | undefined => {
  // Check if the field has enum data type
  if (!fieldParameter.dataType || fieldParameter.dataType.type !== "EnumData") {
    return undefined;
  }

  const defaultValue = fieldParameter.dataType.defaultValue;

  if (!defaultValue) {
    return undefined;
  }

  if (
    typeof defaultValue === "string" ||
    typeof defaultValue === "number" ||
    typeof defaultValue === "boolean"
  ) {
    return options.find((option) => option.value === defaultValue);
  }

  if (isResolvedResource(defaultValue)) {
    return options.find((option) => option.value === defaultValue.value);
  }

  if (isEnumValue(defaultValue)) {
    return options.find((option) => option.value === defaultValue.id);
  }

  if (isExpr(defaultValue)) {
    const resolvedValue = resolveExpression(defaultValue, () => undefined);
    if (typeof resolvedValue === "string") {
      return options.find((option) => option.value === resolvedValue);
    }
    if (isResolvedResource(resolvedValue)) {
      return options.find((option) => option.value === resolvedValue.value);
    }
  }

  return undefined;
};
